import React from 'react';
import { SparkleIcon, HeartIcon } from '@phosphor-icons/react';

export interface DashboardAiSlidePanelChromeProps {
    aiPanelTab: 'ai' | 'tree' | 'saved' | 'wishlist';
    setAiPanelTab: (next: 'ai' | 'tree' | 'saved' | 'wishlist') => void;
    /** 3D viewport mode: icon-only tabs (labels via title / screen reader). */
    iconsOnly?: boolean;
}

/**
 * Slide / map rail: AI designs, Wishlist — same primary tab strip as {@link DashboardAiDesignsTabChrome}.
 */
export const DashboardAiSlidePanelChrome: React.FC<DashboardAiSlidePanelChromeProps> = ({
    aiPanelTab,
    setAiPanelTab,
    iconsOnly = false,
}) => {
    return (
        <div
            className={`obd-ai-rail__tab-stack obd-ai-rail__tab-stack--single-row obd-ai-slide-panel__tab-stack${
                iconsOnly ? ' obd-ai-slide-panel__tab-stack--icons-only' : ''
            }`}
        >
            <div
                className={`obd-ai-rail__tabs obd-ai-rail__tabs--single-row obd-ai-slide-panel__tabs${
                    iconsOnly ? ' obd-ai-slide-panel__tabs--icons-only' : ''
                }`}
                role="tablist"
                aria-label="Designs"
            >
                <button
                    type="button"
                    role="tab"
                    aria-selected={aiPanelTab === 'ai'}
                    title="AI designs"
                    className={`obd-ai-rail__tab obd-ai-rail__tab--single-row ${
                        aiPanelTab === 'ai' ? 'obd-ai-rail__tab--active' : ''
                    }`}
                    onClick={() => setAiPanelTab('ai')}
                >
                    <SparkleIcon size={13} weight="fill" aria-hidden />
                    <span className="obd-ai-rail__tab-label">AI designs</span>
                </button>
                <button
                    type="button"
                    role="tab"
                    aria-selected={aiPanelTab === 'wishlist'}
                    title="Wishlist"
                    className={`obd-ai-rail__tab obd-ai-rail__tab--single-row ${
                        aiPanelTab === 'wishlist' ? 'obd-ai-rail__tab--active' : ''
                    }`}
                    onClick={() => setAiPanelTab('wishlist')}
                >
                    <HeartIcon size={13} weight="fill" aria-hidden />
                    <span className="obd-ai-rail__tab-label">Wishlist</span>
                </button>
            </div>
        </div>
    );
};
